import { hoverHighlight } from "../../theme/tokens";

// gordon-0922-P1-discover-trending-kebab-menu-clone-flash-share-delay-hover:
// @szhsin/react-menu ships UNSTYLED (see WheelCardThreeDotMenu.jsx's own
// kebab-BUTTON hover-overlay comment for the same fact re: the trigger). Its
// hover class (`szh-menu__item--hover`) is applied by the library's OWN JS
// unconditionally on every `<MenuItem>`, regardless of whether the library's
// optional stylesheet (`@szhsin/react-menu/dist/index.css`, which supplies
// `.szh-menu__item--hover { background-color: #ebebeb; }`) is loaded anywhere
// in the page's bundle.
//
// MEASURED live on web-dev.iyuga.net (2026-09-22): the Discover Trending hero
// card's kebab (KebabContextMenu is not used there — it mounts
// WheelCardThreeDotMenu directly, same as Gallery) toggles the hover CLASS
// correctly but paints `rgba(0, 0, 0, 0)` (nothing) on Clone/Share/Report,
// while the identical component mounted from a Gallery wheel card on the SAME
// deployed bundle paints the library's generic `#ebebeb` — present there only
// because that route's chunk happens to also load a component
// (MultiSelect.jsx / IyugaMenu/index.jsx) that imports the library CSS
// directly. Neither result is "on-brand"; both are an accident of whichever
// unrelated component the code-splitter bundled alongside this one.
//
// Fix: stop depending on that external, route-dependent stylesheet. Inject
// ONE always-present rule — shared by every `.szh-menu__item` mount
// (WheelCardThreeDotMenu AND KebabContextMenu, so Discover/Gallery/Collections
// all read the same spec — shared-component law) — using the app's own
// on-brand `hoverHighlight.background` token. `!important` is required: our
// rule and the library's external rule share identical specificity (one
// class), so without it the winner is whichever `<style>` tag happens to land
// in `document.head` last — this makes the result deterministic instead of
// load-order dependent (same rationale WheelCardThreeDotMenu.jsx's own
// `sx={{ color: "... !important" }}` overrides already use against MUI).
export const MENU_ITEM_HOVER_CSS = `
  .szh-menu__item--hover {
    background-color: ${hoverHighlight.background} !important;
  }
`;

const MENU_ITEM_HOVER_STYLE_ATTR = "data-menu-item-hover-style";

export function ensureMenuItemHoverStyleInjected() {
  if (typeof document === "undefined") {
    return;
  }
  const existing = document.head.querySelector(
    `style[${MENU_ITEM_HOVER_STYLE_ATTR}]`
  );
  if (existing) {
    existing.textContent = MENU_ITEM_HOVER_CSS;
    return;
  }
  const styleEl = document.createElement("style");
  styleEl.setAttribute(MENU_ITEM_HOVER_STYLE_ATTR, "true");
  styleEl.textContent = MENU_ITEM_HOVER_CSS;
  document.head.appendChild(styleEl);
}
